module.exports = __webpack_public_path__ + "c2ca011b0855ee8981d8310c29812ec4.jpg";